import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { AppSidebar } from "@/components/sidebar/app-sidebar";
import { Separator } from "@/components/ui/separator";
import { SidebarInset, SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { CompanyTypeOption, getCompanyTypes } from "@/services/companyClassificationApi";

import { COMPANY_TYPE_LABELS } from "./classification";
import { CompaniesTab } from "./CompaniesTab";
import { IndustriesTab } from "./IndustriesTab";
import { OverridesTab } from "./OverridesTab";
import { TiersTab } from "./TiersTab";

const FALLBACK_TYPES: CompanyTypeOption[] = Object.entries(COMPANY_TYPE_LABELS).map(([value, label]) => ({
  value,
  label,
}));

export default function CompanyClassificationPage() {
  const navigate = useNavigate();
  const [tab, setTab] = useState("overrides");
  const [types, setTypes] = useState<CompanyTypeOption[]>(FALLBACK_TYPES);

  useEffect(() => {
    getCompanyTypes(navigate)
      .then(setTypes)
      .catch(() => setTypes(FALLBACK_TYPES));
  }, [navigate]);

  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <header className="flex h-16 shrink-0 items-center gap-2">
          <div className="flex items-center gap-2 px-4">
            <SidebarTrigger className="-ml-1" />
            <Separator orientation="vertical" className="mr-2 h-4" />
            <h1 className="text-sm font-medium">Classification des entreprises & paliers A-player</h1>
          </div>
        </header>

        <div className="space-y-4 p-6">
          <p className="text-sm text-muted-foreground">
            Type d'entreprise = correction manuelle, sinon signaux métier (nom, spécialités, description), sinon
            industrie LinkedIn. Toute modification reclasse les entreprises concernées puis recalcule le type dominant
            de leurs anciens salariés, en quelques minutes.
          </p>

          <Tabs value={tab} onValueChange={setTab}>
            <TabsList>
              <TabsTrigger value="overrides">Corrections</TabsTrigger>
              <TabsTrigger value="industries">Industries</TabsTrigger>
              <TabsTrigger value="companies">Entreprises</TabsTrigger>
              <TabsTrigger value="tiers">Paliers A-player</TabsTrigger>
            </TabsList>
            <TabsContent value="overrides" className="mt-4">
              <OverridesTab types={types} />
            </TabsContent>
            <TabsContent value="industries" className="mt-4">
              <IndustriesTab types={types} />
            </TabsContent>
            <TabsContent value="companies" className="mt-4">
              <CompaniesTab types={types} />
            </TabsContent>
            <TabsContent value="tiers" className="mt-4">
              <TiersTab />
            </TabsContent>
          </Tabs>
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
}
